import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { CrudService, CrudType, IApplicationResponse, ModulesBasedApiSuffix, RxjsService, SnackbarService, addDefaultTableObjectProperties, checkUserPermissionsByCategory, currentComponentPageBasedPermissionsSelector$, onActionSubmittedUtil, prepareDynamicTableTabsFromPermissions, prepareGetRequestHttpParams } from '@app/shared';
import { IT_MANAGEMENT_COMPONENT, UserModuleApiSuffixModels } from '@modules/user';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
@Component({
  selector: 'app-user-group-mapping-list',
  templateUrl: './user-group-mapping-list.component.html',
})
export class UserGroupMappingListComponent extends PrimeNgTableVariablesModel implements OnInit {
  primengTableConfigProperties: any = {
    tableCaption: "Group",
    selectedTabIndex: 0,
    breadCrumbItems: [{ displayName: 'IT Management ', relativeRouterUrl: '' }, { displayName: 'Group List' }],
    tableComponentConfigs: {
      tabsList: [
        {
          caption: 'Group Mapping',
          dataKey: 'groupId',
          enableAction: true,
          columns: [{ field: 'groupName', header: 'Group Name', width: '150px' },
          { field: 'regionName', header: 'Region', width: '130px' },
          { field: 'districtName', header: 'District' },
          { field: 'divisionName', header: 'Division', width: '150px' },
          { field: 'departmentName', header: 'Department' },
          { field: 'areaName', header: 'Area', isparagraph: true },
          { field: 'roleName', header: 'Role', }
          ],
          apiSuffixModel: UserModuleApiSuffixModels.GROUP,
          moduleName: ModulesBasedApiSuffix.IT_MANAGEMENT,
        }]
    }
  }

  constructor(private crudService: CrudService,
    private rxjsService: RxjsService,
    private store: Store<AppState>, private snackbarService: SnackbarService,
    private router: Router) {
    super();
    this.primengTableConfigProperties = addDefaultTableObjectProperties(this.primengTableConfigProperties);
  }

  ngOnInit(): void {
    this.combineLatestNgrxStoreData()
    this.getStockInitiation();
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      let permission = response[0][IT_MANAGEMENT_COMPONENT.GROUP]
      if (permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, permission);
        this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }

  getStockInitiation(pageIndex?: string, pageSize?: string, otherParams?: object): void {
    this.loading = true;
    this.crudService.get(
      ModulesBasedApiSuffix.IT_MANAGEMENT,
      UserModuleApiSuffixModels.GROUP,
      undefined,
      false,
      prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)
    ).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode === 200) {
        this.dataList = response.resources
        this.totalRecords = response.totalCount;
        this.loading = false;
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  onCRUDRequested(type: CrudType | string, row?: object, searchObj?): void {
    switch (type) {
      case CrudType.CREATE:
        if (checkUserPermissionsByCategory.bind(this, CrudType.CREATE)) {
          this.openAddEditPage(CrudType.CREATE, row);
        }
        break;
      case CrudType.GET:
        this.getStockInitiation(row["pageIndex"], row["pageSize"], searchObj);
        break;
      case CrudType.VIEW:
        this.openAddEditPage(CrudType.VIEW, row);
        break;
    }
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string): void {
    switch (type) {
      case CrudType.CREATE:
        this.router.navigate(['user/user-group/add-edit'], { skipLocationChange: true });
        break;
      case CrudType.VIEW:
        this.router.navigate(['user/user-group/view'], { queryParams: { id: editableObject['groupId'] }, skipLocationChange: true });
        break;
    }
  }
}
